import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceApprovalFlow} from './service-approval-flow.model';
import * as ServiceApprovalFlowActions from './service-approval-flow.actions';

export const serviceApprovalFlowsFeatureKey = 'serviceApprovalFlows';

export interface State extends EntityState<ServiceApprovalFlow> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceApprovalFlow> = createEntityAdapter<ServiceApprovalFlow>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceApprovalFlowActions.addServiceApprovalFlow,
    (state, action) => adapter.addOne(action.serviceApprovalFlow, state)
  ),
  on(ServiceApprovalFlowActions.upsertServiceApprovalFlow,
    (state, action) => adapter.upsertOne(action.serviceApprovalFlow, state)
  ),
  on(ServiceApprovalFlowActions.addServiceApprovalFlows,
    (state, action) => adapter.addMany(action.serviceApprovalFlows, state)
  ),
  on(ServiceApprovalFlowActions.upsertServiceApprovalFlows,
    (state, action) => adapter.upsertMany(action.serviceApprovalFlows, state)
  ),
  on(ServiceApprovalFlowActions.updateServiceApprovalFlow,
    (state, action) => adapter.updateOne(action.serviceApprovalFlow, state)
  ),
  on(ServiceApprovalFlowActions.updateServiceApprovalFlows,
    (state, action) => adapter.updateMany(action.serviceApprovalFlows, state)
  ),
  on(ServiceApprovalFlowActions.deleteServiceApprovalFlow,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceApprovalFlowActions.deleteServiceApprovalFlows,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceApprovalFlowActions.loadServiceApprovalFlows,
    (state, action) => adapter.setAll(action.serviceApprovalFlows, state)
  ),
  on(ServiceApprovalFlowActions.clearServiceApprovalFlows,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
